<template>
  <div class="contHandlingType-main">
    <Menus
      :menu="menus"
      icon="https://dsmlib.logistics.systems/Icons/ContainerHandling.png"
      :menuWidth="230"
      @menuClicked="menuClicked"
    />
    <div class="right-container">
      <TableBox
        title="Cont Handling Type"
        :tableData="contHandlingTypeList"
        :selectedRow.sync="selectedContHandlingType"
      />
    </div>

    <PopupEntry
      v-if="popupEntryShow"
      :show.sync="popupEntryShow"
      :title="popupEntryTitle"
      :createdBy="createdBy"
      :disabledSave="popupEntryDisabledSave"
      :updatedBy="updatedBy"
      :viewMode="viewMode"
      :errorMessages.sync="errorMessage"
      :successMessages="successMessage"
      @save="saveContHandlingType"
    >
      <div class="ContHandlingType-code">
        <Input
          validator="alphanumeric,5,uppercase"
          placeholder="Handling Type(max. 5 characters)"
          :inputValue.sync="contHandlingType"
          :errorMessage.sync="handlingTypeError"
          :isRequired="true"
          :isDisabled="viewMode || popupEntryTitle == 'Edit Cont Handling Type'"
          ref="contHandlingType"
        />
      </div>
      <div class="details">
        <RemarksBox
          title="Description (max. 50 characters)"
          :isDisabled="viewMode"
          :inputValue.sync="description"
          :maxLength="50"
          :text.sync="description"
          :errorMessage.sync="handlingTypeDescriptionError"
        />
        <div class="additional-details">
          <Input
            placeholder="Demurrage Days (max. 255 days)"
            :inputValue.sync="DemurrageDays"
            :isDisabled="viewMode"
            :errorMessage.sync="DemurrageDaysError"
            validator="positiveInteger,3"
          />
          <Dropdown
            placeholder="Web View"
            :items="WebViewList"
            :selectedObject.sync="selectedWebView"
            :search.sync="selectedSearch"
            itemKey="label"
            :isDisabled="viewMode"
            :errorMessage.sync="WebViewError"
          />
        </div>
      </div>
    </PopupEntry>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      //side menu list
      menus: [
        {
          title: 'New Cont Handling Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          enabled: true,
          key: 'MnuNew',
          visible: true,
        },
        {
          title: 'Edit Cont Handling Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png',
          enabled: true,
          key: 'MnuEdit',
          visible: true,
        },
        {
          title: 'Delete Cont Handling Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          enabled: true,
          key: 'MnuDelete',
          visible: false,
        },
        {
          title: 'View Cont Handling Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          enabled: true,
          key: 'MnuView',
          visible: true,
        },
      ],

      //table
      contHandlingTypeList: [],
      selectedWebView: null,
      selectedContHandlingType: [],

      //popup entry
      popupEntryShow: false,
      popupEntryTitle: '',
      createdBy: '',
      updatedBy: '',
      viewMode: false,
      errorMessage: [],
      successMessage: [],

      //fields
      contHandlingType: '',
      description: '',
      DemurrageDays: '',
      selectedSearch: '',
      saveAction: '',
      popupEntryDisabledSave: false,

      //error message
      handlingTypeError: '',
      handlingTypeDescriptionError: '',
      DemurrageDaysError: '',
      WebViewError: '',

      //WebView
      WebViewList: [
        { '#': 1, label: 'No', WebViewValue: '0' },
        { '#': 2, label: 'Yes', WebViewValue: '1' },
      ],
    };
  },
  methods: {
    getContHandlingType: async function () {
      this.$fullscreenLoading('Getting Container Handling Type');
      this.contHandlingTypeList = [];
      this.contHandlingTypeList = await this.$apiCallV2('/master/GetListMaster', { masterfile: 'ContHandlingType' });
      this.$fullscreenLoading();
    },

    saveContHandlingType: async function () {
      this.errorMessage = [];
      this.successMessage = [];
      const isValid = this.checkFields();
      if (isValid) {
        const dataToPost = {
          handlingtype: this.contHandlingType,
          handlingtypedesc: this.description,
          action: this.saveAction,
          demurragedays: this.DemurrageDays.length ? this.DemurrageDays : 0,
          webview: this.selectedWebView ? this.selectedWebView['WebViewValue'] : '0',
        };
        this.$fullscreenLoading('Saving Container Handling Type');
        const postUpdate = await this.$apiCallV2('/ContHandlingType/saveContHandlingType', dataToPost);
        this.$fullscreenLoading();
        if (postUpdate[0].Results >= 1) {
          if (this.saveAction == 'N') {
            this.errorMessage.push('There was an error creating Container Handling Type' + postUpdate[0].ErrMsg);
          } else if (this.saveAction == 'E') {
            this.errorMessage.push('There was an error editing Container Handling Type' + postUpdate[0].ErrMsg);
          } else if (this.saveAction == 'D') {
            this.errorMessage.push('There was an error deleting Container Handling Type' + postUpdate[0].ErrMsg);
          }
        } else {
          this.viewMode = true;

          this.popupEntryTitle = 'View Container Handling Type';
          this.popupEntryDisabledSave = true;

          this.getContHandlingType();

          if (this.saveAction == 'N') {
            this.successMessage.push(`Successfully created Container Handling Type: ${this.contHandlingType}`);
          } else if (this.saveAction == 'E') {
            this.successMessage.push(`Successfully edited Container Handling Type: ${this.contHandlingType}`);
          } else if (this.saveAction == 'D') {
            this.$showAlert(
              'success',
              'Container Handling Type Deleted',
              `Successfully deleted ${this.contHandlingType}!`,
            );
            this.selectedContHandlingType = [];
          }
        }
      }
    },
    menuClicked: async function (e) {
      this.popupEntryDisabledSave = false;
      this.clearEntryMessages();
      switch (e['title']) {
        case 'New Cont Handling Type':
          this.clearContHandlingTypeDetails();
          this.popupEntryShow = true;
          this.popupEntryTitle = 'New Cont Handling Type';
          this.saveAction = 'N';
          this.DemurrageDays = '0';
          this.selectedWebView = this.WebViewList[0];
          break;
        case 'Edit Cont Handling Type':
          if (this.selectedContHandlingType.length == 0) {
            this.$showAlert(
              'error',
              'No container handling type selected',
              'Please select a container handling type to edit',
            );
          } else {
            this.popupEntryShow = true;
            this.popupEntryTitle = 'Edit Container Handling Type';
            this.populateContHandlingTypeDetails();
            this.saveAction = 'E';
            await this.populateViewDetails(this.selectedContHandlingType[0]['Handling Type']);
          }
          break;
        case 'View Cont Handling Type':
          if (this.selectedContHandlingType.length == 0) {
            this.$showAlert(
              'error',
              'No container handling type selected',
              'Please select a container handling type to view',
            );
          } else {
            this.popupEntryShow = true;
            this.popupEntryTitle = 'View Container Handling Type';
            this.populateContHandlingTypeDetails();
            this.viewMode = true;
            await this.populateViewDetails(this.selectedContHandlingType[0]['Handling Type']);
          }
          break;
        case 'Delete Cont Handling Type':
          if (this.selectedContHandlingType.length == 0) {
            this.$showAlert(
              'error',
              'No container handling type selected',
              'Please select a container handling type to delete',
            );
          } else {
            const deleting = await this.$showAlert(
              'warning',
              'Delete Container Handling Type',
              `Are you sure you want to delete container handling type ${this.selectedContHandlingType[0]['Handling Type']}? `,
              [
                { text: 'Delete', textColor: 'white', color: 'red' },
                { text: 'Cancel', textColor: 'black', color: 'lightgray' },
              ],
            );

            if (deleting == 'Delete') {
              this.saveAction = 'D';
              this.contHandlingType = this.selectedContHandlingType[0]['Handling Type'];
              this.saveContHandlingType();
            }
          }
          break;
      }
    },
    populateContHandlingTypeDetails: function () {
      this.clearContHandlingTypeDetails();
      this.contHandlingType = this.selectedContHandlingType[0]['Handling Type'];
      this.description = this.selectedContHandlingType[0]['Description'];
    },

    populateViewDetails: async function (record) {
      this.$fullscreenLoading('Getting Details');
      const details = (
        await this.$apiCallV2(`/Master/GetDetailsMaster`, { masterfile: 'CONTHANDLINGTYPE', recordid: record })
      )['ContHandlingType'];
      this.DemurrageDays = details['DemurrageDays'];
      this.updatedBy = details['UserID'] + ' ' + details['DateUpdated'];
      this.createdBy = details['UserCreated'] + ' ' + details['TimeCreated'];
      this.selectedWebView = this.populateObject(this.WebViewList, 'WebViewValue', details['WebView'] || '');
      this.$fullscreenLoading();
    },

    populateObject: function (data, key, compare) {
      //To populate object into dropdown or input query
      try {
        return data.find((d) => d[key].trim() == (compare ? compare.trim() : ''));
      } catch (error) {
        return null;
      }
    },

    clearContHandlingTypeDetails: function () {
      this.viewMode = false;
      this.contHandlingType = '';
      this.description = '';
      this.createdBy = '';
      this.updatedBy = '';
      this.saveAction = '';
      this.successMessage = [];
      this.errorMessage = [];
      this.DemurrageDays = '';
      this.selectedWebView = null;
    },

    checkFields: function () {
      this.clearEntryMessages();
      if (!this.contHandlingType) {
        this.handlingTypeError = 'Container Handling Type is required!';
        this.errorMessage.push('Error! Container Handling Type is required!');
      }
      if (this.contHandlingType.length > 5) {
        this.handlingTypeError = 'Container Handling Type cannot exceed 5 characters!';
        this.errorMessage.push('Error! Container Handling Type cannot exceed 5 characters!');
      }
      if (this.description.length > 50) {
        this.handlingTypeDescriptionError = 'Container Handling Type Description cannot exceed 50 characters!';
        this.errorMessage.push('Error! Description cannot exceed 50 characters!');
      }
      if (this.DemurrageDays > 255) {
        this.DemurrageDaysError = 'Demurrage Days cannot exceed 255!';
        this.errorMessage.push('Error! Demurrage Days cannot exceed 255!');
      }
      if (!this.selectedWebView && this.selectedSearch) {
        this.WebViewError = 'Invalid Web View!';
        this.errorMessage.push('Error! Invalid Web View!');
      }
      return this.errorMessage.length == 0;
    },
    clearEntryMessages: function () {
      this.entryMessages = [];
      this.handlingTypeError = '';
      this.handlingTypeDescriptionError = '';
      this.DemurrageDaysError = '';
      this.WebViewError = '';
    },
  },
  async mounted() {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Cont Handling Type') {
        x.data.forEach((k) => {
          //key in menu same as control value from api
          const selectedMenu = this.menus.find((m) => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
          }
        });
      }
    });
    await this.getContHandlingType();

    if (this.$route.query['new']) {
      this.menuClicked({ title: 'New Container Cont Handling Type' });
    }
  },

  watch: {
    popupEntryShow: async function (val) {
      if (!val && this.$route.query['new'] && !this.viewMode) {
        // When the cancel is click but is not saved (for query new=1)
        const closeWindow = await this.$showAlert(
          'warning',
          'Cancelling Container Handling Type Creation',
          `You have not created an Container Handling Type profile.\nAre you sure you want to cancel?\n\nIf you cancel, this page will close.`,
          [{ text: 'Continue Creating' }, { text: 'Cancel Creating', color: 'red', textColor: 'white' }],
        );

        if (closeWindow == 'Cancel Creating') {
          // If user choose to cancel the creating process, it will close the tab
          window.close();
        } else {
          this.popupEntryShow = true;
        }
      } else if (!val && this.$route.query['new'] && this.viewMode) {
        window.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.contHandlingType-main {
  padding: 10px 45px;
  font-size: 12px;
  display: flex;

  > .right-container {
    width: 100%;
    height: 100%;
    background-color: white;
    padding: 5px;
    margin-left: 5px;
    border-radius: 5px;
  }
}

.additional-details {
  padding-top: 3px;
}
</style>
